import React, {Component} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {filterDemoCycles} from "@irati/insights/utils/demo"
import SchedulesQuery from "@irati/insights/apollo/query/schedule/list"
import {overrideAuth} from "@irati/insights/utils/apollo"
import {DemoTenantContext} from "@irati/insights/context"
import {injectRoute} from "@irati/utils/helpers/routing"

import {Well} from "@irati-web/insights/src/ui/Well"

import {IconTooltip} from "../../ui/Tooltip"
import {ActionsContainer, ScheduleCard} from "../../components/Schedule"
import sitemap from "../../routes/sitemap"


const WellHeader = styled.div`
  display: flex;
  margin-bottom: 9px;
  align-items: center;

  > * {
    margin-right: 6px;
    text-transform: uppercase;
  }
`

const DemoCycleContainer = styled.div`
  padding-top: 30px;
`


class DemoCycleList extends Component {
  static propTypes = {}
  static defaultProps = {}


  constructor(props) {
    super(props)
    this.state = {}
  }

  getDemoParams = (tenantUuid) => {
    const params = {
      tenant: tenantUuid,
      orderBy: "createdAt",
      orderDirection: "DESC"
    }
    return params
  }

  render() {
    const idNamespace = id("demo-cycle-list", this.props, {force: true})
    return (
      <DemoTenantContext.Consumer>
        {({tenantUuid, accessToken, cycleUuid}) => (
          <SchedulesQuery variables={this.getDemoParams(tenantUuid)} Loader={() => null} {...overrideAuth(accessToken)}>
            {({data: {results}, loading}) => {
              const cycleList = filterDemoCycles(results, cycleUuid)
              return (
                <DemoCycleContainer>
                  {!loading &&
                  <Well>
                    <WellHeader>
                      <FormattedMessage id="insights.homepage.demo.title" />
                      <IconTooltip>
                        <FormattedMessage id="insights.homepage.demo.tooltip" />
                      </IconTooltip>
                    </WellHeader>

                    {cycleList.map((cycle) => (
                      <ScheduleCard key={cycle.id} schedule={cycle}>
                        <ActionsContainer>
                          <ButtonRouterLink
                            id={id("View results", idNamespace)}
                            to={injectRoute(sitemap.analysis.url, {scheduleId: cycle.id})}>
                            <FormattedMessage id="insights.cycleCard.cta.seeResults" />
                          </ButtonRouterLink>
                        </ActionsContainer>
                      </ScheduleCard>
                    ))}
                  </Well>}
                </DemoCycleContainer>
              )
            }}
          </SchedulesQuery>
        )}
      </DemoTenantContext.Consumer>
    )
  }
}

export default DemoCycleList
